

function Hero() {

  const instagramUsername = "meo.wmart";

  const handleShopNow = () => {
    const instagramURL = `https://www.instagram.com/${instagramUsername}/`;
    window.open(instagramURL, "_blank");
  };

  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <div className="hero-text">
          <h1>Because Your Friend Deserves Royalty </h1>
          <p>Premium accessories curated with love for your furry family.</p>
          
          <button onClick={handleShopNow}>
            Shop Now 🐾
          </button>

        </div>

        <div className="hero-image">
          <img 
            src="https://venttura.com/cdn/shop/articles/15568347e5c3f9287a17b60c433e8bb9.jpg?v=1737371167&width=1500"
            alt="Cute Cat"
          />
        </div>
      </div>
    </section>
    
  );
}

export default Hero;